import React from 'react';

// html: markup libre escrito por el equipo de marketing en el panel admin (solo lo puede editar un admin autenticado)
export default function HtmlBlock({ html }) {
  if (!html) return null;
  return <div style={{ padding: '0 22px 30px' }} dangerouslySetInnerHTML={{ __html: html }} />;
}
